import { inject, Injectable } from '@angular/core';
import { IxNgLocalStorageService } from 'ix-ng-components';
import { ActivatedRouteSnapshot } from '@angular/router';
import { safeNav2 } from 'ix-ng-core';
import Keycloak from 'keycloak-js';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService extends IxNgLocalStorageService {
  private keycloak = inject(Keycloak);

  override getFromLocalStorage(key: string): Record<string, unknown> {
    let segmentSettings: Record<string, unknown> = {};
    const segmentSettingsLocal = localStorage.getItem(
      `${key}_${this.keycloak.tokenParsed?.sub || 'common'}`,
    );
    if (segmentSettingsLocal !== null) {
      segmentSettings = JSON.parse(segmentSettingsLocal);
    }
    return segmentSettings;
  }

  override saveToLocalStorage(key: string, value: unknown, snapshot: ActivatedRouteSnapshot): void {
    try {
      const segmentSettings: Record<string, unknown> = this.getFromLocalStorage(key);
      let newSegmentSettings: Record<string, unknown> = {};
      const objId: string = safeNav2(
        snapshot,
        (r) => r.data,
        (d) => d['objectCode'],
        null,
      );
      if (objId === null) {
        return;
      }
      newSegmentSettings = { ...segmentSettings };
      newSegmentSettings[objId] = value;
      localStorage.setItem(
        `${key}_${this.keycloak.tokenParsed?.sub || 'common'}`,
        JSON.stringify(newSegmentSettings),
      );
    } catch {
      throw new Error('saveToLocalStorage: Error while saving to local storage');
    }
  }
}
